exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".s8cGOgez5NAijEf-7nX95{margin:0}._3czhlfuA5O9W_xv98mXnbR{margin:0;padding-top:.5em}._10DCplpjjKaeIZuo5vWXYm{margin-top:1.21429rem}._3ty2hKZFcM7UpCUlzOCc-U{float:left}._3ty2hKZFcM7UpCUlzOCc-U:after{background-color:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._3YRcazykoICNCDBS_LSnUC{float:left}._2F9-AASnS-PrWiLp4HWjW0{padding-bottom:.35714rem}.GMVwZPzamBPSZZGssfTZ8{overflow:hidden;padding-bottom:.71429rem}.GMVwZPzamBPSZZGssfTZ8>:not(:last-child){margin-right:1.42857rem}._3ozNY7hlLkkjXKDebIxT-R{padding-bottom:0;padding-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentInformation_container": "_1GF7wVIapw1OIcpaWw_ZRC",
	"StudentInformation_grid": "s8cGOgez5NAijEf-7nX95",
	"StudentInformation_item": "_3czhlfuA5O9W_xv98mXnbR",
	"StudentInformation_button": "_10DCplpjjKaeIZuo5vWXYm",
	"StudentInformation_periodWrapper": "_3ty2hKZFcM7UpCUlzOCc-U",
	"StudentInformation_periodWrapper_item": "_3YRcazykoICNCDBS_LSnUC",
	"StudentInformation_periodWrapper_item_label": "_2F9-AASnS-PrWiLp4HWjW0",
	"StudentInformation_periodWrapper_itemContainer": "GMVwZPzamBPSZZGssfTZ8",
	"StudentInformation_content": "_3ozNY7hlLkkjXKDebIxT-R"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/StudentInformation/style.postcss
// module id = 1773
// module chunks = 0